import { SensorSpecifier } from "verdi-common/schemas/device/subSchemas/sensorSpecifier";
import * as APICommands from "../../APICommands/index.js";
import { findEventually } from "../AMasterIndex.js";
import { Zone } from "../Zone.js";
import { IrrigationDeviceBase } from "./IrrigationDeviceBase.js";

export interface BlockValveOptions {
    enclosureID: string;
    lat: number;
    long: number;
    connectedZones: string[]; // also known as V2
    deviceType: string; // also known as V1
    connectedSensors?: SensorSpecifier[];
    name?: string;
}

export class BlockValve extends IrrigationDeviceBase {
    /**
     * List of all connected Zones
     * @type {Zone[]}
     */
    connectedZones: Zone[] = [];

    /**
     * Creates a new entity of this type and sends it to the server. When the server accepts the new entity, a new local entity
     * is created and this function returns.
     */
    static async createNew(options: BlockValveOptions) {
        return await APICommands.DeviceAPI.addOne(options).then((r) => new BlockValve(r));
    }
    constructor(json) {
        super(json);
        this.category = "blockValve";

        this.assignFromJSON(json);
        this.load().catch((e) => {
            console.warn(e);
        });
    }
    async load() {
        if (this.connectedZoneIDs) {
            this.connectedZones = this.connectedZoneIDs.map(() => undefined);
            const promises = this.connectedZoneIDs.map((czID, i) =>
                findEventually("zone", czID)
                    .then((r) => {
                        this.connectedZones[i] = r;
                        r.devices.push(this);
                    })
                    .catch(() => {
                        console.warn(`Zone ${czID} not found or not loaded`);
                    }),
            );
            while (promises.length > 0) {
                await promises.pop();
            }
        }
        await super.load();
    }

    /**
     * Deletes this entity and returns when the entity has been deleted from the server.
     */
    async delete() {
        await APICommands.DeviceAPI.deleteOne(this.id).then(() => {
            super.delete();
        });
    }
    async edit(args: Record<string, unknown>) {
        const json = await APICommands.DeviceAPI.editOne(this.dbID, args);
        //TODO: add support for changing connected zones
        // if (
        //     (json.zone || json.bot_valve_zone) !== this.zonesByValve[0].id ||
        //     (json.zone || json.top_valve_zone) !== this.zonesByValve[1].id
        // ) {
        //     console.log(`Current Zone zero ID ${this.zonesByValve[0].id}`)
        //     console.log(`New Zone zero ID ${(json.zone || json.top_valve_zone)}`)
        //     console.log(`Current Zone one ID ${this.zonesByValve[1].id}`)
        //     console.log(`New Zone one ID ${(json.zone || json.bot_valve_zone)}`)
        //     window.alert(
        //         "Currently changing the zones of devices is not fully supported" +
        //         "Please reload the page"
        //     );
        // }
        this.assignFromJSON(json);
        this.onChange.trigger({});
        return this;
    }
}
